import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "The Private Gallery", href: "/gallery" },
  { label: "Makler-Service", href: "/makler-service" },
  { label: "Über uns", href: "/ueber-uns" },
  { label: "Kontakt", href: "/kontakt" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 48);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isTransparentPage = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-600 ${
        scrolled || !isTransparentPage || menuOpen
          ? "bg-white border-b border-light-gray"
          : "bg-transparent"
      }`}
    >
      <nav className="px-8 lg:px-16 h-20 flex items-center justify-between max-w-screen-2xl mx-auto">
        {/* Logo */}
        <Link to="/" className="flex flex-col leading-none group">
          <span
            className={`font-serif text-xl font-semibold transition-colors duration-400 ${
              !scrolled && isTransparentPage && !menuOpen
                ? "text-white"
                : "text-text-primary"
            }`}
          >
            SPDB
          </span>
          <span
            className={`text-xs tracking-luxury font-sans font-light transition-colors duration-400 ${
              !scrolled && isTransparentPage && !menuOpen
                ? "text-white/70"
                : "text-text-muted"
            }`}
          >
            STUDIO
          </span>
        </Link>

        {/* Desktop Nav */}
        <ul className="hidden lg:flex items-center gap-10">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.href;
            return (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className={`text-xs tracking-luxury font-sans font-medium uppercase transition-colors duration-400 relative group ${
                    !scrolled && isTransparentPage
                      ? isActive
                        ? "text-gold"
                        : "text-white/80 hover:text-white"
                      : isActive
                      ? "text-gold"
                      : "text-text-secondary hover:text-text-primary"
                  }`}
                >
                  {link.label}
                  <span
                    className={`absolute -bottom-1 left-0 h-px bg-gold transition-all duration-400 ${
                      isActive ? "w-full" : "w-0 group-hover:w-full"
                    }`}
                  />
                </Link>
              </li>
            );
          })}
        </ul>

        {/* CTA */}
        <Link
          to="/kontakt"
          className={`hidden lg:inline-block text-xs tracking-luxury font-sans font-medium uppercase px-6 py-2.5 border transition-all duration-400 whitespace-nowrap ${
            !scrolled && isTransparentPage
              ? "border-white/50 text-white hover:border-gold hover:text-gold"
              : "border-gold text-gold hover:bg-gold hover:text-white"
          }`}
        >
          Anfrage stellen
        </Link>

        {/* Mobile Menu Button */}
        <button
          className={`lg:hidden flex flex-col gap-1.5 p-1 cursor-pointer ${
            !scrolled && isTransparentPage && !menuOpen
              ? "text-white"
              : "text-text-primary"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menü öffnen"
        >
          <span
            className={`block w-6 h-px bg-current transition-transform duration-300 ${
              menuOpen ? "rotate-45 translate-y-2" : ""
            }`}
          />
          <span
            className={`block w-6 h-px bg-current transition-opacity duration-300 ${
              menuOpen ? "opacity-0" : ""
            }`}
          />
          <span
            className={`block w-6 h-px bg-current transition-transform duration-300 ${
              menuOpen ? "-rotate-45 -translate-y-2" : ""
            }`}
          />
        </button>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden bg-white border-t border-light-gray transition-all duration-400 overflow-hidden ${
          menuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <ul className="px-8 py-6 flex flex-col gap-6">
          {navLinks.map((link) => (
            <li key={link.href}>
              <Link
                to={link.href}
                className="text-xs tracking-luxury font-sans font-medium uppercase text-text-secondary hover:text-gold transition-colors duration-300"
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
}
